export default {
    email: [
        v => !!v || 'Email is Required',
        v => /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(v) || 'Please Use A Valid Email Address'
    ],

    password: [
        v => !!v || 'Please choose a password',
        v => v.length > 5 || 'Password Needs to be longer than 6 characters'
    ],

    phone: [
        v => !!v || 'Phone Number Required',
        v => /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/.test(v) || 'Unvalid Phone Number'
    ],

    name: [
        v => !!v || 'Name is required',
        v => v.length < 30 || 'Name is too long'
    ],

    companyName: [
        v => !!v || 'Name is required',
        v => v.length < 30 || 'Name is too long',
        v => v.length > 4 || 'Name is too short',
    ],

    website: [
        v => !!v || 'Website Required',
        v => /^((https?|ftp|smtp):\/\/)?(www.)?[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/.test(v) || 'Invalid URL'
    ],
    address: [
        v => !!v || 'Address Required'
    ],
    company: [
        v => !!v || 'Company Name Required',
    ],
    zip: [
        v => /^[0-9]{5}(?:-[0-9]{4})?$/.test(v) || 'Invalid Zip Code'
    ],
    carrier: [
        v => !!v || 'Select a Carrier or Select Other'
    ],

    category: [
        v => !!v || 'Please Select a Category'
    ]
}